import {
  ABANDONED_CART_CHANNEL,
  FRESH_FEAST_TRIAL_FLOW,
} from "@/constants/state";

export const resolveAcquisitionChannelForFlow = (
  flowSlug: string,
  acSource: string | null,
): string | null => {
  if (flowSlug !== FRESH_FEAST_TRIAL_FLOW) {
    return null;
  }
  if (acSource?.toLowerCase() === ABANDONED_CART_CHANNEL) {
    return ABANDONED_CART_CHANNEL;
  }
  return null;
};
